module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "program"
  }, [_c('i', {
    staticClass: "program-bookmark fa fa-bookmark"
  }), _vm._v(" "), _c('div', {
    class: {
      "program-line": _vm.concentrations.length > 0
    }
  }), _vm._v(" "), _c('unit', {
    attrs: {
      "unit": _vm.unit
    }
  }), _vm._v(" "), _vm._l((_vm.concentrations), function(concentration) {
    return _c('unit', {
      key: concentration.id,
      staticClass: "concentration",
      attrs: {
        "unit": concentration
      }
    })
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27fd3e70","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/program.vue
// module id = 986
// module chunks = 1